module.exports = __webpack_public_path__ + "static/img/TOBIE-TRAVAGLIA.123cb01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TOBIE-TRAVAGLIA.jpg
// module id = rB1F
// module chunks = 0